export type CrdtSyncResponse = {
    delta: Uint8Array
    serverStateVector: Uint8Array
    lastTimestamp: number
}

export type CustomerType = 'legal_assistant' | 'court_reporter' | 'education' | 'media'

export const isVisorCustomer = (customer: CustomerResponse['customer'] | null): boolean => customer?.type === 'legal_assistant'

export type CustomerResponse = {
    customer: {
        id: string
        name: string
        type: CustomerType
        access_to_legal_deposition: boolean
        isSelfService?: boolean
        accessToLiveBookings?: boolean
        hidePricing?: boolean
        ordering_pp_enabled?: boolean
        customizations?: {
            white_labeling_enabled?: boolean
            hide_chat?: boolean
            hide_billing?: boolean
        }
    }
}
